import { ColDef } from 'ag-grid-community'

import { CurrencyCell, DateCell } from '../../tables'

export const MODEL_COLUMN_DEFS: ColDef[] = [
  {
    headerName: 'Name',
    field: 'modelPortfolioName',
    minWidth: 130,
    flex: 0.5
  },
  {
    headerName: 'Trades',
    field: 'numberOfActiveAccounts',
    minWidth: 110,
    flex: 0.2,
    type: 'rightAligned'
  },
  {
    headerName: 'Value',
    field: 'zarValue',
    minWidth: 140,
    flex: 0.3,
    type: 'rightAligned',
    sort: 'desc',
    cellRenderer: CurrencyCell({ fieldName: 'zarValue' })
  }
]

export const FOF_COLUMN_DEFS: ColDef[] = [
  {
    headerName: 'Name',
    field: 'modelPortfolioName',
    minWidth: 130,
    flex: 0.5
  },
  {
    headerName: 'Trades',
    field: 'numberOfActiveAccounts',
    minWidth: 110,
    flex: 0.2,
    type: 'rightAligned'
  },
  {
    headerName: 'Created',
    field: 'startDate',
    minWidth: 140,
    flex: 0.2,
    type: 'rightAligned',
    cellRenderer: DateCell({ fieldName: 'startDate' })
  },
  {
    headerName: 'Last rebalance',
    field: 'lastRebalance',
    minWidth: 160,
    flex: 0.2,
    type: 'rightAligned',
    cellRenderer: DateCell({ fieldName: 'lastRebalance' })
  },
  {
    headerName: 'Value',
    field: 'zarValue',
    minWidth: 140,
    flex: 0.3,
    type: 'rightAligned',
    sort: 'desc',
    cellRenderer: CurrencyCell({ fieldName: 'zarValue' })
  }
]

export const DEFAULT_COLUMN_DEFS: ColDef = {
  sortable: true,
  unSortIcon: true
}
